export default class VendorRisk {
  static Low = 'Low';
  static Medium = 'Medium';
  static High = 'High';
}
